import variables from "../styles/_variables.module.scss"
import {extractNumberFromPx} from "./StringUtilities";

export const primaryNavHeight = extractNumberFromPx(variables["navbar-container-height"]);
export const mobileNavWidth = 1200;

export const regexMap = {
    hashtags: /(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,30})(\b|\r)/g,
    links: /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\S*)?/mi,
    tags: /(^|\B)@(?![0-9_]+\b)([a-zA-Z0-9_]{1,30})(\b|\r)/g,
    html: /<(?:.|\n)*?>/gm,
    mdLink: /\[.*\]\((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\S*)?\)/mi,
    email: /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gmi
};

export const defaultFontFamily = '"Open Sans", sans-serif';


